<template>
  <div class="dialog">
    <el-dialog
      class="formExportAis"
      :visible.sync="changVisible"
      center
      width="600px"
      :modal="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      :before-close="$onClose"
      destroy-on-close
    >
      <el-form id="form_exportAis" method="post" v-loading="loading">
        <input type="input" name="fields" :value="fields" />
        <input type="input" name="order" :value="order" />
        <input type="input" name="where_student_no" :value="where_student_no" />
        <input type="input" name="where_name" :value="where_name" />
        <input type="input" name="where_year" :value="where_year" />
        <input
          type="input"
          name="where_education_status"
          :value="where_education_status"
        />
        <input type="input" name="where_status" :value="where_status" />
        <input type="input" name="where_is_email" :value="where_is_email" />
        <input type="input" name="where_is_account" :value="where_is_account" />
        <input type="input" name="where_programme" :value="where_programme" />
        <input type="input" name="where_division" :value="where_division" />
        <input
          type="input"
          name="where_date_of_birth"
          :value="where_date_of_birth"
        />
        <input type="input" name="where_gender" :value="where_gender" />
        <input type="input" name="where_region" :value="where_region" />
        <input
          type="input"
          name="where_id_card_number"
          :value="where_id_card_number"
        />
        <input
          type="input"
          name="where_admission_category"
          :value="where_admission_category"
        />
        <input
          type="input"
          name="where_honours_classification"
          :value="where_honours_classification"
        />
        <input
          type="input"
          name="where_graduation_year"
          :value="where_graduation_year"
        />
        <input
          type="input"
          name="where_mobile_phone"
          :value="where_mobile_phone"
        />
        <input
          type="input"
          name="where_alumni_email"
          :value="where_alumni_email"
        />
        <input
          type="input"
          name="where_active_email"
          :value="where_active_email"
        />
        <input type="input" name="where_wechat" :value="where_wechat" />
        <input
          type="input"
          name="where_navtive_province"
          :value="where_navtive_province"
        />
        <input
          type="input"
          name="where_navtive_city"
          :value="where_navtive_city"
        />
        <input
          type="input"
          name="where_origin_place"
          :value="where_origin_place"
        />
        <input
          type="input"
          name="where_origin_high_school"
          :value="where_origin_high_school"
        />
        <input type="input" name="where_label" :value="where_label" />
        <input
          type="input"
          name="where_welfare_gymnasium_setting"
          :value="where_welfare_gymnasium_setting"
        />
        <input
          type="input"
          name="where_alumni_type"
          :value="where_alumni_type"
        />
        <input
          type="input"
          name="where_alumni_status"
          :value="where_alumni_status"
        />
        <input
          type="input"
          name="where_member_type"
          :value="where_member_type"
        />
        <input
          type="input"
          name="where_job_organization_nation"
          :value="where_job_organization_nation"
        />
        <input
          type="input"
          name="where_job_organization_province"
          :value="where_job_organization_province"
        />
        <input
          type="input"
          name="where_job_organization_city"
          :value="where_job_organization_city"
        />
        <input
          type="input"
          name="where_job_organization"
          :value="where_job_organization"
        />
        <input
          type="input"
          name="where_job_unit_property"
          :value="where_job_unit_property"
        />
        <input
          type="input"
          name="where_job_type"
          :value="where_job_type"
        />
        <input
          type="input"
          name="where_job_position"
          :value="where_job_position"
        />
        <input
          type="input"
          name="where_job_pay"
          :value="where_job_pay"
        />
        <input
          type="input"
          name="where_job_registered_address"
          :value="where_job_registered_address"
        />
        <input
          type="input"
          name="where_job_employees"
          :value="where_job_employees"
        />
        <input
          type="input"
          name="where_job_turnover"
          :value="where_job_turnover"
        />
        <input
          type="input"
          name="where_job_freelance"
          :value="where_job_freelance"
        />
        <input
          type="input"
          name="where_education_nation"
          :value="where_education_nation"
        />
        <input
          type="input"
          name="where_education_province"
          :value="where_education_province"
        />
        <input
          type="input"
          name="where_education_city"
          :value="where_education_city"
        />
        <input
          type="input"
          name="where_education_school"
          :value="where_education_school"
        />
        <input
          type="input"
          name="where_education_programme"
          :value="where_education_programme"
        />
        <input
          type="input"
          name="where_education_graduation_year"
          :value="where_education_graduation_year"
        />
        <input
          type="input"
          name="where_education_other"
          :value="where_education_other"
        />
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import { URL_PATH } from "@/config/config";
import * as StrUtils from "@/utils/strUtils.js";
import * as Constant from "@/utils/constant.js";
import * as CApi from "@/api/constant_api.js";

export default {
  data() {
    return {
      changVisible: false,
      loading: true,
      token: localStorage.getItem("token"),
      fields: "",
      order: "",
      where_student_no: "",
      where_name: "",
      where_year: "",
      where_education_status: "",
      where_status: "",
      where_is_email: "",
      where_is_account: "",
      where_programme: "",
      where_division: "",
      where_date_of_birth: "",
      where_gender: "",
      where_region: "",
      where_id_card_number: "",
      where_admission_category: "",
      where_honours_classification: "",
      where_graduation_year: "",
      where_mobile_phone: "",
      where_alumni_email: "",
      where_active_email: "",
      where_wechat: "",
      where_navtive_province: "",
      where_navtive_city: "",
      where_origin_place: "",
      where_origin_high_school: "",
      where_label: "",
      where_welfare_gymnasium_setting: "",
      where_alumni_type: "",
      where_alumni_status: "",
      where_member_type: "",
      where_job_organization_nation: "",
      where_job_organization_province: "",
      where_job_organization_city: "",
      where_job_organization: "",
      where_job_unit_property: "",
      where_job_type: "",
      where_job_position: "",
      where_job_pay: "",
      where_job_registered_address: "",
      where_job_employees: "",
      where_job_turnover: "",
      where_job_freelance: "",
      where_education_nation: "",
      where_education_province: "",
      where_education_city: "",
      where_education_school: "",
      where_education_programme: "",
      where_education_graduation_year: "",
      where_education_other: ""
    };
  },
  methods: {
    $onClose(done) {
      done();
    },
    close() {
      this.changVisible = false;
    },
    //页面初始化时加载的事件
    show(
      checkList,
      order,
      where_student_no,
      where_name,
      where_year,
      where_education_status,
      where_status,
      where_is_email,
      where_is_account,
      where_programme,
      where_division,
      where_date_of_birth,
      where_gender,
      where_region,
      where_id_card_number,
      where_admission_category,
      where_honours_classification,
      where_graduation_year,
      where_mobile_phone,
      where_alumni_email,
      where_active_email,
      where_wechat,
      where_navtive_province,
      where_navtive_city,
      where_origin_place,
      where_origin_high_school,
      where_label,
      where_welfare_gymnasium_setting,
      where_alumni_type,
      where_member_type,
      where_alumni_status,
      where_job_organization_nation,
      where_job_organization_province,
      where_job_organization_city,
      where_job_organization,
      where_job_unit_property,
      where_job_type,
      where_job_position,
      where_job_pay,
      where_job_registered_address,
      where_job_employees,
      where_job_turnover,
      where_job_freelance,
      where_education_nation,
      where_education_province,
      where_education_city,
      where_education_school,
      where_education_programme,
      where_education_graduation_year,
      where_education_other
    ) {
      this.changVisible = true;
      this.fields = StrUtils.getAisInfoFields(checkList);
      this.order = order;
      this.where_student_no = where_student_no;
      this.where_name = where_name;

      this.where_year =
        where_year.length == 0 ? "" : where_year[0] + "-" + where_year[1];
      this.where_date_of_birth =
        where_date_of_birth.length == 0
          ? ""
          : where_date_of_birth[0] + "-" + where_date_of_birth[1];
      this.where_graduation_year =
        where_graduation_year.length == 0
          ? ""
          : where_graduation_year[0] + "-" + where_graduation_year[1];

      this.where_is_email = StrUtils.isEmpty(where_is_email)
        ? ""
        : where_is_email === Constant.num_2_options[0]
        ? "1"
        : "0";
      this.where_is_account = StrUtils.isEmpty(where_is_account)
        ? ""
        : where_is_account === Constant.num_2_options[0]
        ? "1"
        : "0";
      this.where_gender = StrUtils.isEmpty(where_gender)
        ? ""
        : where_gender === Constant.gender_options[0]
        ? "M"
        : "F";
      if (where_education_status != null) {
        this.where_education_status = StrUtils.replaceFields(
          where_education_status.toString()
        );
      }
      if (where_programme != null) {
        this.where_programme = StrUtils.replaceFields(
          where_programme.toString()
        );
      }
      if (where_alumni_type != null) {
        this.where_alumni_type = StrUtils.replaceFields(
          where_alumni_type.toString()
        );
      }
      if (where_status != null) {
        this.where_status = StrUtils.replaceFields(where_status.toString());
      }
      if (where_region != null) {
        this.where_region = StrUtils.replaceFields(where_region.toString());
      }
      if (where_welfare_gymnasium_setting != null) {
        this.where_welfare_gymnasium_setting = StrUtils.replaceFields(
          where_welfare_gymnasium_setting.toString()
        );
      }
      if (where_alumni_status != null) {
        this.where_alumni_status = StrUtils.replaceFields(
          where_alumni_status.toString()
        );
      }
      if (where_member_type != null) {
        this.where_member_type = StrUtils.replaceFields(
          where_member_type.toString()
        );
      }
      this.where_division = where_division;
      this.where_id_card_number = where_id_card_number;
      this.where_admission_category = where_admission_category;
      this.where_honours_classification = where_honours_classification;
      this.where_mobile_phone = where_mobile_phone;
      this.where_alumni_email = where_alumni_email;
      this.where_active_email = where_active_email;
      this.where_wechat = where_wechat;
      this.where_navtive_province = where_navtive_province;
      this.where_navtive_city = where_navtive_city;
      this.where_origin_place = where_origin_place;
      this.where_origin_high_school = where_origin_high_school;
      this.where_label = where_label;
      this.where_job_unit_property = StrUtils.replaceFields(
        where_job_unit_property.toString()
      );
      this.where_job_type = StrUtils.replaceFields(where_job_type.toString());
      this.where_job_pay = StrUtils.replaceFields(where_job_pay.toString());
      this.where_job_employees = StrUtils.replaceFields(where_job_employees.toString());
      this.where_job_turnover = StrUtils.replaceFields(where_job_turnover.toString());
      this.where_job_organization_nation = where_job_organization_nation;
      this.where_job_organization_province = where_job_organization_province;
      this.where_job_organization_city = where_job_organization_city;
      this.where_job_organization = where_job_organization;
      this.where_job_position = where_job_position;
      this.where_job_registered_address = where_job_registered_address;
      this.where_job_freelance = where_job_freelance;
      this.where_education_programme = where_education_programme;
      this.where_education_nation = where_education_nation;
      this.where_education_province = where_education_province;
      this.where_education_city = where_education_city;
      this.where_education_school = where_education_school;
      this.where_education_other = where_education_other;
      this.where_education_graduation_year =
        where_education_graduation_year.length == 0
          ? ""
          : where_education_graduation_year[0] +
            "-" +
            where_education_graduation_year[1];

      this.$nextTick(() => {
        const from = document.getElementById("form_exportAis");
        from.action =
          URL_PATH + CApi.api_exportAisLatestInfo + "?token=" + this.token;
        from.submit();
        this.close();
      });
    },
    showSelectInfo(
      fieldArr,
      order,
      where_student_no,
      where_name,
      where_year,
      where_education_status,
      where_status,
      where_is_email,
      where_is_account,
      where_programme,
      where_division,
      where_date_of_birth,
      where_gender,
      where_region,
      where_id_card_number,
      where_admission_category,
      where_honours_classification,
      where_graduation_year,
      where_mobile_phone,
      where_alumni_email,
      where_active_email,
      where_wechat,
      where_navtive_province,
      where_navtive_city,
      where_origin_place,
      where_origin_high_school,
      where_label,
      where_welfare_gymnasium_setting,
      where_alumni_type,
      where_member_type,
      where_alumni_status,
      where_job_organization_nation,
      where_job_organization_province,
      where_job_organization_city,
      where_job_organization,
      where_job_unit_property,
      where_job_type,
      where_job_position,
      where_job_pay,
      where_job_registered_address,
      where_job_employees,
      where_job_turnover,
      where_job_freelance,
      where_education_nation,
      where_education_province,
      where_education_city,
      where_education_school,
      where_education_programme,
      where_education_graduation_year,
      where_education_other
    ) {
      this.changVisible = true;
      this.fields = fieldArr;
      this.order = order;
      this.where_student_no = where_student_no;
      this.where_name = where_name;

      this.where_year =
        where_year.length == 0 ? "" : where_year[0] + "-" + where_year[1];
      this.where_date_of_birth =
        where_date_of_birth.length == 0
          ? ""
          : where_date_of_birth[0] + "-" + where_date_of_birth[1];
      this.where_graduation_year =
        where_graduation_year.length == 0
          ? ""
          : where_graduation_year[0] + "-" + where_graduation_year[1];

      this.where_is_email = StrUtils.isEmpty(where_is_email)
        ? ""
        : where_is_email === Constant.num_2_options[0]
        ? "1"
        : "0";
      this.where_is_account = StrUtils.isEmpty(where_is_account)
        ? ""
        : where_is_account === Constant.num_2_options[0]
        ? "1"
        : "0";
      this.where_gender = StrUtils.isEmpty(where_gender)
        ? ""
        : where_gender === Constant.gender_options[0]
        ? "M"
        : "F";
      if (where_education_status != null) {
        this.where_education_status = StrUtils.replaceFields(
          where_education_status.toString()
        );
      }
      if (where_programme != null) {
        this.where_programme = StrUtils.replaceFields(
          where_programme.toString()
        );
      }
      if (where_alumni_type != null) {
        this.where_alumni_type = StrUtils.replaceFields(
          where_alumni_type.toString()
        );
      }
      if (where_status != null) {
        this.where_status = StrUtils.replaceFields(where_status.toString());
      }
      if (where_region != null) {
        this.where_region = StrUtils.replaceFields(where_region.toString());
      }
      if (where_welfare_gymnasium_setting != null) {
        this.where_welfare_gymnasium_setting = StrUtils.replaceFields(
          where_welfare_gymnasium_setting.toString()
        );
      }
      if (where_alumni_status != null) {
        this.where_alumni_status = StrUtils.replaceFields(
          where_alumni_status.toString()
        );
      }
      if (where_member_type != null) {
        this.where_member_type = StrUtils.replaceFields(
          where_member_type.toString()
        );
      }
      this.where_division = where_division;
      this.where_id_card_number = where_id_card_number;
      this.where_admission_category = where_admission_category;
      this.where_honours_classification = where_honours_classification;
      this.where_mobile_phone = where_mobile_phone;
      this.where_alumni_email = where_alumni_email;
      this.where_active_email = where_active_email;
      this.where_wechat = where_wechat;
      this.where_navtive_province = where_navtive_province;
      this.where_navtive_city = where_navtive_city;
      this.where_origin_place = where_origin_place;
      this.where_origin_high_school = where_origin_high_school;
      this.where_label = where_label;
      this.where_job_unit_property = StrUtils.replaceFields(
        where_job_unit_property.toString()
      );
      this.where_job_type = StrUtils.replaceFields(where_job_type.toString());
      this.where_job_pay = StrUtils.replaceFields(where_job_pay.toString());
      this.where_job_employees = StrUtils.replaceFields(where_job_employees.toString());
      this.where_job_turnover = StrUtils.replaceFields(where_job_turnover.toString());
      this.where_job_organization_nation = where_job_organization_nation;
      this.where_job_organization_province = where_job_organization_province;
      this.where_job_organization_city = where_job_organization_city;
      this.where_job_organization = where_job_organization;
      this.where_job_position = where_job_position;
      this.where_job_registered_address = where_job_registered_address;
      this.where_job_freelance = where_job_freelance;
      this.where_education_programme = where_education_programme;
      this.where_education_nation = where_education_nation;
      this.where_education_province = where_education_province;
      this.where_education_city = where_education_city;
      this.where_education_school = where_education_school;
      this.where_education_other = where_education_other;
      this.where_education_graduation_year =
        where_education_graduation_year.length == 0
          ? ""
          : where_education_graduation_year[0] +
            "-" +
            where_education_graduation_year[1];

      this.$nextTick(() => {
        const from = document.getElementById("form_exportAis");
        from.action =
          URL_PATH + CApi.api_exportSelectInfo + "?token=" + this.token;
        from.submit();
        this.close();
      });
    }
  },
};
</script>

<style lang="less" scoped>
.formExportAis {
  visibility: hidden;
}
input {
  visibility: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/dialog/exportAisLatestInfoDialog.vue